module.exports = {
    brandInfo: {
        phoneNumber: "15878870645",
        contactEmail: "info@carkarma.ca",
        address: `4915 54 Street Red Deer AB`,
        copyright: `© ${new Date().getFullYear()} Car Karma`,
        defaultCampaignId: "218",
    },

    images: {
        logo: "images/logo.png",
        icon: "images/favicon.png",
    },

    project: "can-credit-application",
    name: "Car Karma",
    description: "Get the best rates ever",

    siteUrl: "https://www.carkarma.ca/",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,

    layout: {
        component: require.resolve("./src/layout/index.jsx"),
        theme: require.resolve("./themes/custom/single-page-theme.js"),
    },
};